import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    relations: [],
    isLoading: false,
    error: null
}

const donorRelationsSlice = createSlice({
    name: "donorRelations",
    initialState,
    reducers: {
        loadRelations(state, action) {
            state.relations = action.payload.relations;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload
        },
        setError(state, action) {
            state.error = action.payload
        },
        clearError(state) {
            state.error = null
        },
        resetState: () => initialState,
    },
});

export const donorRelationsActions = donorRelationsSlice.actions;
export default donorRelationsSlice;

